// extracted by mini-css-extract-plugin
export default {"lang_chooser":"languageChooser_lang_chooser__qVmZQ"};